var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDEstartupLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 73,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#DEstartup_logo_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#DEstartup_logo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61.376 10.694H66.5v-2.38h-6.163c-3.318 0-4.684 1.816-4.684 4.659v.277c-.556-3.346-2.593-4.937-6.32-4.937h-6.248C40.565 3.387 35.367 0 29.34 0 20.878 0 14 6.723 14 15.005 14 23.288 20.878 30 29.34 30c5.985 0 11.162-3.336 13.692-8.21h6.374c1.523 0 2.898-.093 4.294-1.181 1.008-.78 1.639-1.889 1.932-3.336v4.496h2.92v-5.286h6.898v-2.35h-6.909l.042-.955c.01-1.55.494-2.484 2.793-2.484ZM49.27 19.409h-3.224v-8.714h3.224c2.53 0 3.444 1.058 3.444 4.362 0 3.295-.904 4.352-3.444 4.352Z",
  fill: "#C8DFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.134 13.886h1.91c1.513 0 2.405-.297 2.405-1.55 0-1.292-.892-1.652-2.446-1.652h-6.458v-2.37h7.518c3.812 0 4.358 2.606 4.358 4.064 0 1.55-.651 4.003-4.358 4.003h-1.848c-2.31 0-2.803.81-2.803 2.36v.719h8.63v2.299h-11.58v-3.336c0-2.853 1.364-4.536 4.672-4.536Z",
  fill: "#2A46BD"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "DEstartup_logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.981)",
  d: "M0 0h71.667v30H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "DEstartup_logo_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(14)",
  d: "M0 0h52.5v30H0z"
})))));
export default SvgDEstartupLogo;